import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty'

import { Placeholder } from '../Placeholder';
import HeroImageUnavailable from '../HeroImageUnavailable';

import { PHOTO_OBJECT_TYPE } from './types';

export default function LayoutSm({
    image = {},
    showUnavailableImage = false
}) {
    if (showUnavailableImage) {
        return (
            <div className="sarsa-hero-image-gallery-layout sm">
                <HeroImageUnavailable />
            </div>
        );
    }

    // If we don't have an image
    if (isEmpty(image)) {
        return (
            <div className="sarsa-hero-image-gallery-layout sm">
                <Placeholder height="100%" />
                {/* <div className="photo hero" /> */}
            </div>
        );
    }

    const heroStyle = image?.url
        ? { backgroundImage: `url(${image.url})` }
        : null;

    return (
        <div className="sarsa-hero-image-gallery-layout sm">
            <div
                className="photo hero"
                style={heroStyle}
                role="img"
                aria-label={image.altText} />
        </div>
    );
}

LayoutSm.propTypes = {
    image: PHOTO_OBJECT_TYPE,
    showUnavailableImage: PropTypes.bool
};
